import { Spinner } from "@/components/ui/Spinner";
import { ExploreCollectionPanel } from "@/components/explore/ExploreCollectionPanel";
import { useExploreOverview } from "@/hooks/useExploreAdmin";
import { getErrorMessage } from "@/services/api";

export function AdminExploreCollectionPage() {
  const overview = useExploreOverview();

  return (
    <section aria-label="Collection" className="space-y-4">
      <div>
        <h2 className="text-base font-semibold">Collection</h2>
        <p className="mt-1 text-sm text-muted-foreground">
          Run Google and X collection jobs, monitor active runs, and review
          execution history.
        </p>
      </div>

      {overview.isLoading ? (
        <div className="flex h-24 items-center justify-center">
          <Spinner size="md" />
        </div>
      ) : overview.error ? (
        <div className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
          {getErrorMessage(overview.error, "Failed to load collection status.")}
        </div>
      ) : overview.data ? (
        <ExploreCollectionPanel overview={overview.data} />
      ) : null}
    </section>
  );
}
